export default {
  props: {
    eventId: [Number, String, Object],
    locationId: [Number, String, Object],
    sTime: [String],
    sDate: [String],
    isWalkin: [Number, String, Object],
    propListFilter: Object,
    minFilterDateTime: String,
    maxFilterDateTime: String,
    showWaitlist: Boolean,
    showColumns: Object
  }
}
